<template>
  <div>
    <a-spin :spinning="isloading" tip="加载中...">
      <div class>
        <div class="pxkeji-right-box">
          <a-form class="ant-advanced-search-form">
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item label="资料名称">
                  <a-input placeholder="请输入" v-model="where.keyword.testName" />
                </a-form-item>
              </a-col>
              <!-- <a-col :span="8">
                <a-form-item label="状态">
                  <a-select v-model="where.keyword.examStatus" allowClear>
                    <a-select-option value>全部</a-select-option>
                    <a-select-option value="0">未发布</a-select-option>
                    <a-select-option value="1">进行中</a-select-option>
                    <a-select-option value="2">已结束</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <a-col :span="16" :style="{ textAlign: 'right' }">
                <a-button type="primary" @click="searchList">搜索</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="pxkeji-right-box" style="margin-top:0">
          <a-table
            :columns="list.columns"
            rowKey="id"
            :pagination="list.pagination"
            @change="onChange"
            :dataSource="list.datas"
            :loading="isloading"
            :rowSelection="{type:'radio',onChange:onRowChange,selectedRowKeys:selectRows}"
            :locale="{emptyText:'暂无数据'}"
          >
            <span slot="status" slot-scope="status">
              <a-tag v-if="status==0" color="blue">未发布</a-tag>
              <a-tag v-else-if="status==1" color="green">进行中</a-tag>
              <a-tag v-else color="red">已结束</a-tag>
            </span>
            <span slot="action" slot-scope="info">
              <pxkeji-btn name="编辑" :roles="[]" size="small" @click="showInfo(info)" type="primary" />
              <a-divider type="vertical" />
              <pxkeji-btn
                name="删除"
                :roles="[]"
                size="small"
                @click="delInfo(info.id)"
                type="default"
              />
            </span>
          </a-table>
        </div>
        <a-row :gutter="24">
          <a-col :span="24" :style="{ textAlign: 'center' }">
            <a-button type="primary" @click="choseBack">选择并返回</a-button>
          </a-col>
        </a-row>
      </div>
    </a-spin>
  </div>
</template>

<script>
var that;
const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "资料编号"
  },
  {
    dataIndex: "testName",
    key: "testName",
    align: "center",
    title: "资料名称"
  },
  {
    dataIndex: "questionsCount",
    key: "questionsCount",
    align: "center",
    title: "格式"
  },
  {
    dataIndex: "price",
    key: "price",
    align: "center",
    title: "资料价格"
  },
  {
    dataIndex: "passLine",
    key: "passLine",
    align: "center",
    title: "使用有效期"
  },
  {
    dataIndex: "addUser",
    key: "addUser",
    align: "center",
    title: "发布者"
  },
];
export default {
  props: {
    id: Number,
    type: Number
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          parentName: "",
          typeName: ""
        }
      },
      selectRows: [], //选中项编号
      selectdata: {}, //选择撤机选项
      isloading: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.id) this.selectRows = [this.id];
      this.GetList();
    });
  },
  methods: {
    GetList() {
      //获取列表
      this.list.datas = [{
          id: "1",
          testName: "测试课程",
          questionsCount: "20",
          price: "100",
          passLine: "2020-10-01",
          addUser: "张三"
      }]
    //   this.isloading = true;
    //   this.clearRows();
    //   this.$api.examination
    //     .getPageList(
    //       this.list.pagination.current,
    //       this.list.pagination.defaultPageSize,
    //       this.where.keyword.testName,
    //       this.where.keyword.examStatus
    //     )
    //     .then(res => {
    //       this.isloading = false;
    //       if (res.errorCode == this.$msg.responseCode.success) {
    //         this.list.datas = res.data.records;
    //         this.list.pagination.total = Number(res.data.total);
    //       } else {
    //         this.$message.error(res.errorMsg);
    //       }
    //     })
    //     .catch(() => {
    //       this.isloading = false;
    //     });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    //table 单选
    onRowChange(selectedRowKeys, selectedRows) {
      this.selectRows = selectedRowKeys;
      this.selectdata = selectedRows;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    //选择并返回
    choseBack() {
      if (this.selectRows) {
        this.$emit("callbackMethod", this.selectdata[0]);
      }
    }
  }
};
</script>
<style>
</style>